module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_gc_lb3@2x.467daa3c.png";